import { render, staticRenderFns } from "./ShowAttachmentModal.vue?vue&type=template&id=4828f4fc&scoped=true&"
import script from "./ShowAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./ShowAttachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ShowAttachmentModal.vue?vue&type=style&index=0&id=4828f4fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828f4fc",
  null
  
)

export default component.exports